import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/home_banner.png';
import _imports_1 from '@/assets/images/home_area1.png';
import _imports_2 from '@/assets/images/home_area2.png';
import _imports_3 from '@/assets/images/logo2.png';
const _withScopeId = n => (_pushScopeId("data-v-5ddbb801"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "wrap"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bannerBox"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_4 = {
  class: "category-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title absolute font-bold"
}, "门诊预约导诊", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title absolute font-bold"
}, "重疾住院手术安排含导诊", -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title absolute font-bold"
}, "检查加急", -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"copyrightBox\" data-v-5ddbb801><div class=\"item\" data-v-5ddbb801>   © <a href=\"https://beian.miit.gov.cn\" target=\"_blank\" data-v-5ddbb801>京ICP备2023040768号-2</a></div><div class=\"item flexCenter\" data-v-5ddbb801><img src=\"" + _imports_3 + "\" alt=\"\" data-v-5ddbb801><a href=\"https://beian.mps.gov.cn/#/query/webSearch?code=11010802044072\" target=\"_blank\" data-v-5ddbb801>京公网安备11010802044072</a></div></div>", 1);
import { useRouter } from 'vue-router';
import { ref, getCurrentInstance } from 'vue';
import cache from '@/utils/cache';
import { Loading } from 'vant';
import { serverLog } from '@/api/index';
export default {
  setup(__props) {
    const router = useRouter();
    let InterValObj = null;
    const {
      proxy
    } = getCurrentInstance();
    getTokenInfo();
    function getTokenInfo() {
      try {
        InterValObj = window.setInterval(function () {
          if (cache.session.getJSON('loginInfo') && cache.session.getJSON('loginInfo').access_token) {
            window.clearInterval(InterValObj);
          } else {
            proxy.$toast.loading({
              message: '加载中...',
              duration: 0,
              forbidClick: true
            });
          }
          ;
        }, 1000);
      } finally {
        proxy.$toast.clear();
        console.log(1);
      }
    }
    const handleJump = async type => {
      try {
        if (cache.session.getJSON('loginInfo') && cache.session.getJSON('loginInfo').access_token) {
          //存在token
          const {
            code,
            data
          } = await serverLog({
            serviceType: type == 1 ? 10 : type == 2 ? 20 : type == 3 ? 30 : ''
          });
          if (code === 200) {
            router.push({
              path: '/writeForm',
              query: {
                type
              }
            });
          }
          ;
        } else {
          proxy.$toast.loading({
            message: '获取授权失败',
            forbidClick: true
          });
        }
        ;
      } catch (err) {} finally {}
      ;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "category-list-item relative cp-mb-15",
        onClick: _cache[0] || (_cache[0] = $event => handleJump(1))
      }, _hoisted_7), _createElementVNode("div", {
        class: "category-list-item relative cp-mb-15",
        onClick: _cache[1] || (_cache[1] = $event => handleJump(2))
      }, _hoisted_10), _createElementVNode("div", {
        class: "category-list-item relative",
        onClick: _cache[2] || (_cache[2] = $event => handleJump(3))
      }, _hoisted_13)])]), _hoisted_14]);
    };
  }
};